import DrDabber from "../assets/images/west-coast-brands/dr-dabber.webp";
import FocusV from "../assets/images/west-coast-brands/focus-v.webp";
import HuniBadger from "../assets/images/west-coast-brands/huni-badger.webp";
import Lookah from "../assets/images/west-coast-brands/lookah.png";
import NewportZero from "../assets/images/west-coast-brands/newport-zero.webp";
import Ocb from "../assets/images/west-coast-brands/ocb.png";
import Polkadot from "../assets/images/west-coast-brands/polkadot.webp";
import Puffco from "../assets/images/west-coast-brands/puffco.png";
import Raw from "../assets/images/west-coast-brands/raw.jpg";
import CCell from "../assets/images/west-coast-brands/ccell.png";
import Cheech from "../assets/images/west-coast-brands/cheech.png";
import Cookies from "../assets/images/west-coast-brands/cookies.jpg";
import CosmicGas from "../assets/images/west-coast-brands/cosmic-gas.png";
import Stoned from "../assets/images/west-coast-brands/stoned.webp";

/* BRANDS */
const brands = [
  {
    id: 1,
    logo: DrDabber,
    routes: "/brands/dr-dabber",
    label: "Dr Dabber",
  },
  {
    id: 2,
    logo: FocusV,
    routes: "/brands/focusv",
    label: "Focus V",
  },
  {
    id: 3,
    logo: HuniBadger,
    routes: "/brands/huni-badger",
    label: "Huni Badger",
  },
  {
    id: 4,
    logo: Lookah,
    routes: "/brands/lookah",
    label: "Lookah",
  },
  {
    id: 5,
    logo: NewportZero,
    routes: "/brands/newport-zero",
    label: "Newport Zero",
  },
  {
    id: 6,
    logo: Ocb,
    routes: "/brands/ocb",
    label: "OCB",
  },
  {
    id: 7,
    logo: Polkadot,
    routes: "/brands/polkadot",
    label: "Polkadot",
  },
  {
    id: 8,
    logo: Puffco,
    routes: "/brands/puffco",
    label: "Puffco",
  },
  {
    id: 9,
    logo: Raw,
    routes: "/brands/raw",
    label: "Raw",
  },
  {
    id: 10,
    logo: CCell,
    routes: "/brands/ccell",
    label: "C-Cell",
  },
  {
    id: 11,
    logo: Cheech,
    routes: "/brands/cheech",
    label: "Cheech",
  },
  {
    id: 12,
    logo: Cookies,
    routes: "/brands/cookies",
    label: "Cookies",
  },
  {
    id: 13,
    logo: CosmicGas,
    routes: "/brands/cosmic-gas",
    label: "Cosmic Gas",
  },
  {
    id: 14,
    logo: Stoned,
    routes: "/brands/stoned",
    label: "Stoned",
  },
];

export default brands;
